<template>
 <pre>{{info}}</pre>
</template>
<script>
export default {
  props: {
    info: String
  }
}
</script>


// WEBPACK FOOTER //
// Info.vue?59ab8f15